var map = {
	"./btob.png": "2zOy",
	"./btoc.png": "bKQ3",
	"./commerce.png": "PooQ",
	"./construction.png": "4Jfh",
	"./estate.png": "JFlb",
	"./finance.png": "fsm5",
	"./healthcare.png": "Hr82",
	"./hero-finance.png": "7DVm",
	"./hero/iso.png": "Lm5l",
	"./hero/privacy.png": "H9xM",
	"./logistics.png": "BDg6",
	"./manufacturing.png": "oJhx",
	"./media.png": "8AuH",
	"./outsourcing.png": "DE0A",
	"./professional.png": "u5sf",
	"./retail.png": "zL1H",
	"./software.png": "+bBy",
	"./travel.png": "fAWy"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+k2c";